import { resolveIsOnPremise } from "@frontend-shared/utils/deployment-settings";

import { useAppConfig } from "@/api/app-config/useAppConfig";
import { isOnPremise } from "@/env/env";

interface IUseOnPremiseResult {
  isOnPremise: boolean;
}

// NOTE: NSAI-1606 — the server's /app-config says whether this deployment is
// on-premise; VITE_ON_PREMISE answers only until it resolves, and when it
// cannot be read.
export const useOnPremise = (): IUseOnPremiseResult => {
  const { data: appConfig } = useAppConfig();

  return {
    isOnPremise: resolveIsOnPremise({
      appConfig,
      buildValue: isOnPremise(),
    }),
  };
};
